// @ts-nocheck
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { RangePicker } from '../../../../components/ant/DatePicker';
import Field from '../../../../components/card/Field';
import OrgUnitSelect from '../../../../components/OrgUnitSelect';
import { formatDateTimeToISOString } from '../../../../lib/helpers';
import { Filter, FilterButtonsContainer, FilterContainer, FilterItem, Selects } from './../../../../components';
const SpoilerContent = styled.div.withConfig({
  displayName: "Filter__SpoilerContent",
  componentId: "sc-1nazf0t-0"
})(["padding:16px;"]);
const {
  BrandsSelect,
  VehicleTypeSelect,
  FuelGroupSelect,
  VehicleSelect
} = Selects;
const ReportFuelCardsFilter = ({
  style,
  filter,
  applyFilter,
  cleanFilter
}) => <SpoilerContent style={{
  ...style
}}>
    <FilterContainer>
      <Filter initialValues={filter} applyFilter={applyFilter} cleanFilter={cleanFilter} additionalFilter>
        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter,
        showAdditional,
        handleAdditional
      }) => <>
            <FilterItem>
              <Field mBottomNone>
                <BrandsSelect size="small" value={values.brandId} mode="multiple" onChange={ids => changeValue('brandId', ids)} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <VehicleTypeSelect size="small" value={values.type} selectableGroup onChange={types => changeValue('type', types)} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker size="small" format="DD.MM.YYYY HH:mm" showTime={{
              format: 'HH:mm',
              defaultValue: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')]
            }} placeholder={['Начало', 'Конец']} value={[values.startDate ? moment.utc(values.startDate) : null, values.endDate ? moment.utc(values.endDate) : null]} onChange={(value, dateString) => {
              const [startDate, endDate] = value;
              const [startDateString, endDateString] = dateString;
              changeValue('startDate', formatDateTimeToISOString(startDate, startDateString));
              changeValue('endDate', formatDateTimeToISOString(endDate, endDateString));
            }} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <FuelGroupSelect size="small" value={values.fuelGroup} onChange={fuelGroup => changeValue('fuelGroup', fuelGroup)} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <VehicleSelect size="small" value={values.vehicleId} mode="multiple" optionTitle={vehicle => vehicle.licensePlate} onChange={ids => changeValue('vehicleId', ids)} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect size="small" value={values.orgUnitId} onChange={id => changeValue('orgUnitId', id)} />
              </Field>
            </FilterItem>
            <FilterButtonsContainer applyFilter={applyFilter} cleanFilter={cleanFilter} handleAdditional={handleAdditional} showAdditional={showAdditional} />
          </>}
      </Filter>
    </FilterContainer>
  </SpoilerContent>;
export default ReportFuelCardsFilter;
